import { ButtonGroup, Card, Button } from "@mui/material";
import { FormComponentFactory } from "./FormComponentFactory";
import { Component } from "./Component";
import { registerDataTableComponent } from "./components/DataTableComponent";
import { registerTreeViewComponent } from "./components/TreeViewComponent";
import { registerSelectComponent } from "./components/SelectComponent";
import { registerListComponent } from "./components/ListComponent";
import { registerButtonComponent } from "./components/ButtonComponent";
import { registerActionComponent } from "./components/ActionComponent";

export function ComponentPalette({
  addConfig,
}: {
  addConfig: (config: Component) => void;
}) {
  const components = FormComponentFactory.availableTypes();
  const buttons = components.map((component) => (
    <Button key={component} onClick={() => addComponent(component)}>
      {component}
    </Button>
  ));
  const addComponent = (component: string) => {
    addConfig(FormComponentFactory.generateConfig(component));
  };
  return (
    <Card>
      <ButtonGroup orientation="horizontal">{buttons}</ButtonGroup>
    </Card>
  );
}
registerDataTableComponent();
registerTreeViewComponent();
registerSelectComponent();
registerListComponent();
registerButtonComponent();
registerActionComponent();
